import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined'
import HubOutlinedIcon from '@mui/icons-material/HubOutlined'
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew'
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined'
import { Box } from '@mui/material'
import { FC } from 'react'
import { FilterList, FilterListItem, FilterLiveSearch, List, ListProps, useTranslate } from 'react-admin'
import { RestrictedCreateButton } from '../../components'
import { EmptyState, FilterAside, PageHeader, pageSx } from '../../components/ui'
import { CERTIFICATE_WRITE_SCOPE } from '../../config'
import { useHasScope } from '../../hooks/useHasScope'
import { CertificateStatus } from '../../types/apiRequests'
import { CertificateDatagrid } from './CertificateColumns'
import { targetSystemChoices, typeChoices } from './targetSystems'

// Filters the API supports (CertificateFilterableFields); each takes a list of values.
const CertificateFilters: FC = () => {
  const translate = useTranslate()
  return (
    <FilterAside>
      {/* q: hostname, environment, interface or contact. */}
      <FilterLiveSearch source="q" placeholder={translate('resources.certificates.search')} sx={{ mb: 1.5 }} />
      <FilterList label={translate('resources.certificates.fields.targetSystem')} icon={<HubOutlinedIcon />}>
        {targetSystemChoices.map(({ id, name }) => (
          <FilterListItem key={id} label={name} value={{ targetSystem: [id] }} />
        ))}
      </FilterList>
      <FilterList label={translate('resources.certificates.fields.status')} icon={<PowerSettingsNewIcon />}>
        {Object.values(CertificateStatus).map(value => (
          <FilterListItem key={value} label={`resources.certificates.status.${value}`} value={{ status: [value] }} />
        ))}
      </FilterList>
      <FilterList label={translate('resources.certificates.fields.type')} icon={<CategoryOutlinedIcon />}>
        {typeChoices.map(({ id, name }) => (
          <FilterListItem key={id} label={name} value={{ type: [id] }} />
        ))}
      </FilterList>
    </FilterAside>
  )
}

const CertificatesList: FC<ListProps> = (props) => {
  const translate = useTranslate()
  const canWrite = useHasScope(CERTIFICATE_WRITE_SCOPE)
  const createButton = <RestrictedCreateButton scope={CERTIFICATE_WRITE_SCOPE} />

  return (
    <Box sx={pageSx}>
      <PageHeader
        title={translate('resources.certificates.title')}
        subtitle={translate('resources.certificates.subtitle')}
        actions={createButton}
      />
      <List
        {...props}
        exporter={false}
        actions={false}
        aside={<CertificateFilters />}
        sort={{ field: 'created', order: 'DESC' }}
        empty={
          <EmptyState
            icon={<WorkspacePremiumOutlinedIcon />}
            title={translate('resources.certificates.empty.title')}
            text={translate(canWrite ? 'resources.certificates.empty.text' : 'resources.certificates.empty.textReadOnly')}
            action={createButton}
          />
        }
      >
        <CertificateDatagrid rowClick="show" />
      </List>
    </Box>
  )
}

export default CertificatesList
